import { CrewMember } from '@legacy-types';

import { api } from '@shared/api/api';
import { toQueryString } from '@shared/api/helpers';
import { PaginatedResourceResponse, PartialQuery } from '@shared/api/types';

export function getCrewMembersForRegistration(registrationId: number, query?: PartialQuery) {
  const queryString = query ? `?${toQueryString(query)}` : '';

  return api.get<PaginatedResourceResponse<CrewMember>>(`registrations/${registrationId}/crew-members/${queryString}`);
}
